import { ICommonConfigurations } from './environment.model';

// Email format for all environments. Keep identical to ValidationService.DEFAULT_EMAIL_REGEX.
export const EMAIL_VALIDATOR_REGEX =
    '^[_a-z0-9A-Z+-]+(\\.[_a-zA-Z0-9+-]+)*@[_a-z0-9A-Z-]+(\\.[_a-zA-Z0-9-]+)*(\\.[a-zA-Z]{2,})$';

export const commonConfigurations: ICommonConfigurations = {
    CdnBaseUrl: `https://az-cdn.selise.biz/selisecdn/cdn/`,
    CdnTenantBaseUrl: `https://az-cdn.selise.biz/selisecdn/cdn/pcx/`,
    SiteLogo: `https://az-cdn.selise.biz/selisecdn/cdn/pcx/images/ipex_logo.svg`,
    topBgImageUrl: `https://az-cdn.selise.biz/selisecdn/cdn/pcx/`,
    Client_ID: `8ABDFF27-1C30-4781-B3EF-1E6245314358`,
    NotificationHubName: `NotifierServerHub`,
    PersonFields: [
        `ItemId`,
        `CreatedBy`,
        `Tags`,
        `DateOfBirth`,
        `Sex`,
        `FirstName`,
        `LastName`,
        `ProfileImage`,
        `Email`,
        `DisplayName`,
        `ProfileImageId`,
        `Salutation`,
        `Nationality`,
        `PhoneNumber`,
        `Organization`,
        `OrganizationId`,
        `LastLogInTime`,
        `LogInCount`,
        `ColorCode`,
        `ProposedUserId`,
        'IsVerified'
    ],
    toBgImages: [`images/ipex_logo.svg`],
   // toBgImages: [`backgrounds/top-bground.jpg`],
    currentDateFormat: `dd MMM yyyy`,
    defaultLangKey: `de`,
    currency: `EUR`,
    DefaultPackagePath: './assets/i18n/generic-app/',
    language: [
        {
            id: `en`,
            title: `ENGLISH`,
            flag: `us`,
            value: `en-US`
        },
        {
            id: `de`,
            title: `GERMAN`,
            flag: `de`,
            value: `de-DE`
        },
        {
            id: `fr`,
            title: `FRENCH`,
            flag: `fr`,
            value: `fr-FR`
        },
        {
            id: `it`,
            title: `ITALIAN`,
            flag: `it`,
            value: `it-IT`
        }
    ],
    isFloatingChatPanelEnable: true,
    EmailValidatorRegex: EMAIL_VALIDATOR_REGEX,
};
